import Markdown from 'markdown-to-jsx'
import { ComponentPropsWithoutRef, ElementType } from 'react'

interface Props extends ComponentPropsWithoutRef<'div'> {
  wrapper?: ElementType
}

export const MarkdownHeading = ({
  children,
  wrapper = 'h2',
  ...props
}: Props) => {
  const Wrapper = wrapper
  return (
    <Wrapper {...props}>
      <Markdown
        options={{
          overrides: {
            p: ({ children }) => children,
          },
        }}
      >
        {`${children}`}
      </Markdown>
    </Wrapper>
  )
}
